var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { transparentize } from 'polished';
import styled from '../styled-components';
var Divider = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  margin: ", ";\n  flex: 0 0 0;\n  display: flex;\n  width: 100%;\n"], ["\n  border-top: 1px solid ", ";\n  margin: ", ";\n  flex: 0 0 0;\n  display: flex;\n  width: 100%;\n"])), function (p) { return transparentize(0.8)(p.theme.colorBody); }, function (p) { return p.margin || '1.5rem 0 0.5rem 0'; });
export default Divider;
var templateObject_1;
